const VIEWPORT_ROOT_MARGIN = '200px 0px'
const VIEWPORT_MARGIN_PX = 200

export class RingbaLoader {

    lazyLoadEnabled = false
    scriptLoaded = false
    metadata = null
    intersectionObserver = null
    observedElements = new WeakSet()
    observedElementCount = 0
    pendingObserveElements = new Set()
    ensureLoadedCallback = null

    loadWhenVisible(metadata, ensureLoadedCallback) {

        if (this.scriptLoaded || window._rgba?.loading) {
            return
        }

        this.lazyLoadEnabled = true
        this.metadata = metadata
        this.ensureLoadedCallback = ensureLoadedCallback
        this.ensureIntersectionObserver()

        for (const element of this.pendingObserveElements) {
            this.observeElement(element)
        }

        this.pendingObserveElements.clear()
        this.updateLazyState()

    }

    registerElement(element) {

        if (!element || this.scriptLoaded) {
            return
        }

        if (!this.lazyLoadEnabled) {

            this.pendingObserveElements.add(element)

            return

        }

        this.ensureIntersectionObserver()
        this.observeElement(element)

    }

    ensureLoaded() {

        if (this.scriptLoaded || window._rgba?.loading) {
            return
        }

        if (!this.metadata || !this.ensureLoadedCallback) {
            return
        }

        try {
            this.ensureLoadedCallback(this.metadata)
        } catch (error) {

            console.error(error)

            return

        }

        this.scriptLoaded = true
        this.teardownObservers()
        this.updateLazyState()

    }

    teardownObservers() {

        if (this.intersectionObserver) {

            this.intersectionObserver.disconnect()
            this.intersectionObserver = null

        }

        this.pendingObserveElements.clear()
        this.updateLazyState()

    }

    observeElement(element) {

        if (this.scriptLoaded || !this.intersectionObserver || this.observedElements.has(element)) {
            return
        }

        this.observedElements.add(element)
        this.observedElementCount++
        this.intersectionObserver.observe(element)

        if (this.isNearViewport(element)) {
            this.ensureLoaded()
        }

        this.updateLazyState()

    }

    isNearViewport(element) {

        const rect = element.getBoundingClientRect()

        return rect.top < window.innerHeight + VIEWPORT_MARGIN_PX
            && rect.bottom > -VIEWPORT_MARGIN_PX

    }

    ensureIntersectionObserver() {

        if (this.intersectionObserver || this.scriptLoaded || window._rgba?.loading) {
            return
        }

        this.intersectionObserver = new IntersectionObserver(entries => {

            if (this.scriptLoaded) {
                return
            }

            if (entries.some(entry => entry.isIntersecting)) {
                this.ensureLoaded()
            }

        }, {
            rootMargin: VIEWPORT_ROOT_MARGIN,
            threshold: 0,
        })

    }

    updateLazyState() {

        if (!this.lazyLoadEnabled) {
            return
        }

        window.__RINGBA_LAZY_STATE = {
            lazyLoadEnabled: this.lazyLoadEnabled,
            scriptLoaded: this.scriptLoaded,
            intersectionObserver: this.intersectionObserver !== null,
            observedElementCount: this.observedElementCount,
            pendingObserveElementCount: this.pendingObserveElements.size,
            observersActive: this.intersectionObserver !== null,
        }

    }

}
